import { render, staticRenderFns } from "./adminPanel.vue?vue&type=template&id=ace76e44"
import script from "./adminPanel.vue?vue&type=script&lang=js"
export * from "./adminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ace76e44')) {
      api.createRecord('ace76e44', component.options)
    } else {
      api.reload('ace76e44', component.options)
    }
    module.hot.accept("./adminPanel.vue?vue&type=template&id=ace76e44", function () {
      api.rerender('ace76e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/GpsViews/Admin/AdminPanel/adminPanel.vue"
export default component.exports